import { ReschedulerProps } from './types';
import { ReschedulerProvider } from '@contexts/rescheduler';
import { RelatedSchedulesDialog } from '@components/schedules/dialogs/related';
import { ScheduleDialog } from './dialog';
import { ScheduleConfirmationDialog } from '@components/schedules/dialogs/internal/confirmation';

export const Rescheduler = (props: ReschedulerProps) => (
  <ReschedulerProvider>
    <ScheduleDialog {...props} />
    <RelatedSchedulesDialog />
    <ScheduleConfirmationDialog />
  </ReschedulerProvider>
);
